module.exports = __webpack_public_path__ + "static/media/cloud_watch1.b93de8f3.png";